import PropTypes from "prop-types";
import React from "react";

import ProviderDetailModal from "./ProviderDetailModal";
import ProviderDetailPage from "./ProviderDetailPage";

export default function ProviderDetail({
  presentation = "modal",
  providerDetail,
  open = false,
  setOpen = () => {},
}) {
  if (presentation === "page") {
    return <ProviderDetailPage providerDetail={providerDetail} />;
  }

  return <ProviderDetailModal providerDetail={providerDetail} open={open} setOpen={setOpen} />;
}

ProviderDetail.propTypes = {
  open: PropTypes.bool,
  presentation: PropTypes.oneOf(["modal", "page"]),
  providerDetail: PropTypes.object,
  setOpen: PropTypes.func,
};
